import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ReferralsService} from './referrals.service';
import {ValidValuesService} from '../valid-values/valid-values.service';
import {DoctorsService} from '../../../services/doctors.service';
import {ReferringDoctorDataModel} from './models/referring-doctor-data.model';
import {
    ReferralScheduleDataModel,
    ReferralTreatmentsDataModel,
    ReferralOtherServicesDataModel,
    ReferralProviderDataModel
} from './models/referral-data.model';
import {TdoTableV2Component} from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {Globals} from '../../../globals';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {AuthenticationService} from '../../auth/services/authentication.service';
import {DoctorQueryOptionsModel} from '../../../models/doctors/doctor-query-options.model';
import {TdoTableRowModel} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-row.model';
import {MenuConfigurationModel} from '../../../models/ui/menu/menu-configuration.model';
import {EnumValidValueModel} from '../../../models/enum/enum-valid-value.model';
import {DialogService} from '../../../services/dialog.service';
import {StaticDataService} from '../../../services/static-data.service';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {ConfigurationService} from '../configuration.service';
import {Constants} from "../../../constants";

@Component({
    selector: 'app-referral-configuration',
    templateUrl: './referral-configuration.component.html',
    styleUrls: ['./referral-configuration.component.scss']
})
export class ReferralConfigurationComponent implements OnInit {
    @ViewChild('referralOtherServiceTable') referralOtherServiceTable: TdoTableV2Component;
    @ViewChild('referralScheduleTable') referralScheduleTable: TdoTableV2Component;
    @ViewChild('referralTreatmentTable') referralTreatmentTable: TdoTableV2Component;
    @ViewChild('doctTable') doctTable: TdoTableV2Component;

    @ViewChild('focusSchedule', {static: false}) inputSchedule: ElementRef;
    @ViewChild('focusTreatment', {static: false}) inputTreatment: ElementRef;
    @ViewChild('focusOtherService', {static: false}) inputOtherService: ElementRef;

    referringDocs: ReferringDoctorDataModel[] = null;
    procedures: ReferralTreatmentsDataModel[] = [];
    otherServices: ReferralOtherServicesDataModel[] = [];
    schedule: ReferralScheduleDataModel[];
    discomfortLevel: any[] = [];
    currentReferringDr: ReferringDoctorDataModel = new ReferringDoctorDataModel();
    currentProvider: ReferralProviderDataModel;
    copyFromSelectedProvider: ReferralProviderDataModel;
    newMode = false;
    newDiscomfortMode = false;

    showSameAs: boolean = false;

    newDoc: ReferringDoctorDataModel = null;
    newDiscomfort: EnumValidValueItemModel = null;
    // newSchedule: ReferralScheduleDataModel = null;
    // newServices: ReferralOtherServicesDataModel = null;
    // newTreatment: ReferralTreatmentsDataModel = null;
    doctorList: ReferralProviderDataModel[] = [];
    enumReferralScheduleType: EnumValidValueItemModel[] = [];
    selectedEnumReferralScheduleType: EnumValidValueItemModel;
    searchPredicate: any;
    queryModel: DoctorQueryOptionsModel;


    selectedReferralSchedule: ReferralScheduleDataModel;
    selectedReferralTreatment: ReferralTreatmentsDataModel;
    selectedReferralOtherService: ReferralOtherServicesDataModel;

    constructor(
        public apiService: ReferralsService, public validValueService: ValidValuesService, public doctorService: DoctorsService,
        public globals: Globals,
        private authenticationService: AuthenticationService,
        private dialogService: DialogService,
        private staticDataService: StaticDataService,
        public configurationService: ConfigurationService,
    ) {
        this.selectedReferralSchedule = new ReferralScheduleDataModel();
        this.selectedReferralTreatment = new ReferralTreatmentsDataModel();
        this.selectedReferralOtherService = new ReferralOtherServicesDataModel();
    }

    async ngOnInit() {
        console.log(this.currentReferringDr.RefDoctorID);
        this.queryModel = new DoctorQueryOptionsModel();
        this.queryModel.isActiveOnly = false;
        this.queryModel.isIncludeTdo = true;
        this.queryModel.isIncludeReferring = false;
        this.queryModel.isLazyLoad = true;
        if (this.staticDataService.validValueItems && this.staticDataService.validValueItems.length > 0) {
            this.enumReferralScheduleType = this.staticDataService.getValidValueItemsByValidValueName('enumReferralScheduleType');
        } else {
            this.staticDataService.validValuesReadyEvent.subscribe({
                complete: () => {
                    this.enumReferralScheduleType = this.staticDataService.getValidValueItemsByValidValueName('enumReferralScheduleType');
                }
            });
        }

        await this.doctorService.getDoctors(this.queryModel).subscribe(dataDoc => {

            dataDoc.forEach(dr => {
                this.doctorList.push({
                    providerName: dr.dataContact.FirstName + ' ' + dr.dataContact.LastName,
                    providerID: dr.DoctorId.toString()
                });
            });
            this.currentProvider = this.doctorList[0];
            console.log(this.currentProvider);
            this.apiService.getReferralDocsByProvider(this.currentProvider.providerID).subscribe(data3 => {
                this.referringDocs = data3;
                this.reloadReferralTables();
            });

        });
    }

    onRowSelectedTreatment(event: TdoTableSelectionEvent) {
        const l = this.configurationService.checkIsDirty();
        if (l) {
            l.subscribe((res) => {
                if (res) {
                    this.selectedReferralTreatment = event.model;
                    return;
                } else {
                    this.referralTreatmentTable.selectionControl.select(this.selectedReferralTreatment);
                }
            });
        } else {
            this.selectedReferralTreatment = event.model;
        }
    }

    onRowSelectedOtherService(event: TdoTableSelectionEvent) {
        const l = this.configurationService.checkIsDirty();
        if (l) {
            l.subscribe((res) => {
                if (res) {
                    this.selectedReferralOtherService = event.model;
                    return;
                } else {
                    this.referralOtherServiceTable.selectionControl.select(this.selectedReferralOtherService);
                }
            });
        } else {
            this.selectedReferralOtherService = event.model;
        }
    }

    onRowSelectedSchedule(event: TdoTableSelectionEvent) {
        const l = this.configurationService.checkIsDirty();
        if (l) {
            l.subscribe((res) => {
                if (res) {
                    this.selectedReferralSchedule = event.model;
                    return;
                } else {
                    this.referralScheduleTable.selectionControl.select(this.selectedReferralSchedule);
                }
            });
        } else {
            this.selectedReferralSchedule = event.model;
        }
    }


    onDeleteSchedule(row: TdoTableRowModel, event: MouseEvent) {
        event.stopImmediatePropagation();
        this.dialogService.openConfirmDialog(`Are you sure you want to delete ${row.model.ItemName}?`).subscribe((result) => {
            if (result === true) {
                const model = row.model;
                const idx = this.schedule.findIndex(p => p === model);
                if (idx > -1) {
                    this.schedule.splice(idx, 1);
                    this.referralScheduleTable.updateData();
                    if (model.ReferralScheduleItemID === Constants.emptyGuid) {
                        return;
                    }
                    this.apiService.deleteReferralSchedule(model.ReferralScheduleItemID).subscribe();
                }
            } else {
            }
        });
    }

    onDeleteTreatment(row: TdoTableRowModel, event: MouseEvent) {
        event.stopImmediatePropagation();
        this.dialogService.openConfirmDialog(`Are you sure you want to delete ${row.model.ItemName}?`).subscribe((result) => {
            if (result === true) {
                const model = row.model;
                const idx = this.procedures.findIndex(p => p === model);
                if (idx > -1) {
                    this.procedures.splice(idx, 1);
                    this.referralTreatmentTable.updateData();
                    if (model.ReferralTretmentID === Constants.emptyGuid) {
                        return;
                    }
                    this.apiService.deleteReferralTreatment(model.ReferralTretmentID).subscribe();
                }
            } else {
            }
        });
    }


    onDeleteOtherService(row: TdoTableRowModel, event: MouseEvent) {
        event.stopImmediatePropagation();
        this.dialogService.openConfirmDialog(`Are you sure you want to delete ${row.model.ItemName}?`).subscribe((result) => {
            if (result === true) {
                const model = row.model;
                const idx = this.otherServices.findIndex(p => p === model);
                if (idx > -1) {
                    this.otherServices.splice(idx, 1);
                    this.referralOtherServiceTable.updateData();

                    if (model.ReferralOtherID === Constants.emptyGuid) {
                        return;
                    }
                    this.apiService.deleteReferralOtherService(model.ReferralOtherID).subscribe();
                }
            } else {
            }
        });
    }


    async saveReferralSchedule(row: TdoTableRowModel, referralSchedule: ReferralScheduleDataModel, itemSaved: string = '') {
        if (row.model.ReferralScheduleItemID === Constants.emptyGuid) {
            if (referralSchedule.ItemDescription === '' || referralSchedule.ItemName === '' || referralSchedule.enumReferralScheduleTypeID === Constants.emptyGuid) {
                return;
            }
            this.apiService.saveReferralSchedule(referralSchedule).subscribe(data => {
                this.selectedReferralSchedule = data;
                const idx = this.schedule.findIndex(p => p.ItemName === data.ItemName || p.ItemDescription === data.ItemDescription);
                this.schedule[idx] = data;
                this.referralScheduleTable.updateData();
                //this.referralScheduleTable.updateData(this.schedule);
                // this.referralScheduleTable.updateData(this.schedule.sort((a, b) => b.iOrder - a.iOrder));
            });
        } else {
            if (itemSaved === 'ItemName') {
                row.model.ItemName = referralSchedule.ItemName === '' ? row.model.ItemName : referralSchedule.ItemName;
            } else if (itemSaved === 'ItemDescription') {
                row.model.ItemDescription = referralSchedule.ItemDescription === '' ? row.model.ItemDescription : referralSchedule.ItemDescription;
            } else if (itemSaved === 'enumReferralScheduleTypeID') {
                row.model.enumReferralScheduleTypeID = referralSchedule.enumReferralScheduleTypeID === Constants.emptyGuid ? row.model.enumReferralScheduleTypeID : referralSchedule.enumReferralScheduleTypeID;
            } else if (itemSaved === 'Order') {
                row.model.iOrder = referralSchedule.iOrder === 0 ? row.model.iOrder : referralSchedule.iOrder;
            }
            await this.apiService.saveReferralSchedule(row.model).subscribe(data => {
                const idx = this.schedule.findIndex(p => p.ReferralScheduleItemID === data.ReferralScheduleItemID);
                this.schedule[idx] = data;
                const ivl = setInterval(() => {
                    if (!this.referralScheduleTable) {
                        return;
                    }
                    clearInterval(ivl);
                    // this.referralScheduleTable.updateData(this.schedule);
                    // this.referralScheduleTable.updateData(this.schedule.sort((a, b) => b.iOrder - a.iOrder));
                }, 10);
            });
        }
    }

    async saveReferralTreatment(row: TdoTableRowModel, referralTreatment: ReferralTreatmentsDataModel, itemSaved: string = '') {
        if (row.model.ReferralTretmentID === Constants.emptyGuid) {
            if (referralTreatment.ItemDescription === '' || referralTreatment.ItemName === '') {
                return;
            }
            this.apiService.saveReferralTreatment(referralTreatment).subscribe(data => {
                this.selectedReferralTreatment = data;
                const idx = this.procedures.findIndex(p => p.ItemName === data.ItemName || p.ItemDescription === data.ItemDescription);
                this.procedures[idx] = data;
                // this.referralTreatmentTable.updateData(this.procedures);
                this.referralTreatmentTable.updateData();
            });
        } else {
            if (itemSaved === 'ItemName') {
                row.model.ItemName = referralTreatment.ItemName === '' ? row.model.ItemName : referralTreatment.ItemName;
            } else if (itemSaved === 'ItemDescription') {
                row.model.ItemDescription = referralTreatment.ItemDescription === '' ? row.model.ItemDescription : referralTreatment.ItemDescription;
            } else if (itemSaved === 'Order') {
                row.model.iOrder = referralTreatment.iOrder === 0 ? row.model.iOrder : referralTreatment.iOrder;
            }
            await this.apiService.saveReferralTreatment(row.model).subscribe(data => {
                const idx = this.procedures.findIndex(p => p.ReferralTretmentID === data.ReferralTretmentID);
                this.procedures[idx] = data;
                const ivl = setInterval(() => {
                    if (!this.referralTreatmentTable) {
                        return;
                    }
                    clearInterval(ivl);
                    // this.referralTreatmentTable.updateData(this.procedures);
                }, 10);
            });
        }
    }


    async saveReferralOtherService(row: TdoTableRowModel, referralOtherService: ReferralOtherServicesDataModel, itemSaved: string = '') {
        if (row.model.ReferralOtherID === Constants.emptyGuid) {
            if (referralOtherService.ItemDescription === '' || referralOtherService.ItemName === '') {
                return;
            }
            this.apiService.saveReferralService(referralOtherService).subscribe(data => {
                this.selectedReferralOtherService = data;
                const idx = this.otherServices.findIndex(p => p.ItemName === data.ItemName || p.ItemDescription === data.ItemDescription);
                this.otherServices[idx] = data;
                //this.referralOtherServiceTable.updateData(this.otherServices);
                this.referralOtherServiceTable.updateData();

            });
        } else {
            if (itemSaved === 'ItemName') {
                row.model.ItemName = referralOtherService.ItemName === '' ? row.model.ItemName : referralOtherService.ItemName;
            } else if (itemSaved === 'ItemDescription') {
                row.model.ItemDescription = referralOtherService.ItemDescription === '' ? row.model.ItemDescription : referralOtherService.ItemDescription;
            } else if (itemSaved === 'Order') {
                row.model.iOrder = referralOtherService.iOrder === 0 ? row.model.iOrder : referralOtherService.iOrder;
            }
            await this.apiService.saveReferralService(row.model).subscribe(data => {
                const idx = this.otherServices.findIndex(p => p.ReferralOtherID === data.ReferralOtherID);
                this.otherServices[idx] = data;
                const ivl = setInterval(() => {
                    if (!this.referralOtherServiceTable) {
                        return;
                    }
                    clearInterval(ivl);
                    // this.referralOtherServiceTable.updateData(this.otherServices);
                }, 10);
            });
        }
    }


    async changeDr(doc) {
        console.log(this.currentProvider.providerID);
        this.currentProvider = doc.value;
        this.schedule = null;
        this.otherServices = null;
        this.procedures = null;
        this.referringDocs = null;
        this.apiService.getReferralDocsByProvider(this.currentProvider.providerID).subscribe(dataDrs => {

            this.referringDocs = dataDrs;

        });
        await this.reloadReferralTables();
    }

    async reloadReferralTables() {
        await this.apiService.getTreatments(this.currentProvider.providerID).subscribe(data => {
            this.otherServices = data;

            this.apiService.getProcedures(this.currentProvider.providerID).subscribe(data2 => {
                this.procedures = data2;

            });
            this.apiService.getSchedule(this.currentProvider.providerID).subscribe(data3 => {
                this.schedule = data3;
            });
        });
    }

    async copyFromSelectedDr(doc) {
        console.log(this.currentProvider.providerID);
        this.copyFromSelectedProvider = doc.value;
        this.showSameAs = false;
        this.apiService.copyFromSelectedDr(this.copyFromSelectedProvider.providerID, this.currentProvider.providerID).subscribe(result => {
            if (result) {
                this.reloadReferralTables();
            }
        });
    }

    createNewSchedule() {
        const highest = Number(this.schedule.sort((a, b) => b.iOrder - a.iOrder)[0].iOrder);
        this.selectedReferralSchedule = {
            ReferralScheduleItemID: Constants.emptyGuid,
            DoctorId: this.currentProvider.providerID,
            ItemName: '',
            ItemDescription: '',
            ItemParameter: '',
            isEdit: true,
            iOrder: highest + 1, // this.schedule.length ?? 0,
            enumReferralScheduleTypeID: Constants.emptyGuid,
            xauditCreatedBy: this.authenticationService.currentUserValue.authdata.userid,
            xauditCreatedOn: undefined,
            xauditDeleted: false,
            xauditModifiedBy: this.authenticationService.currentUserValue.authdata.userid,
            xauditModifiedOn: undefined,
            xauditTableRowID: ''
        };
        // this.selectedReferralSchedule = this.newSchedule;
        this.schedule.unshift(this.selectedReferralSchedule);
        this.referralScheduleTable.updateData(this.schedule.sort((a, b) => b.iOrder - a.iOrder));
        setTimeout(() => { // this will make the execution after update table has changed
            this.referralScheduleTable.setSelectedModel(this.selectedReferralSchedule);
            this.inputSchedule.nativeElement.focus();
        }, 10);

    }

    createNewTreatment() {
        const highest = Number(this.procedures.sort((a, b) => b.iOrder - a.iOrder)[0].iOrder);
        this.selectedReferralTreatment = {
            ReferralTretmentID: Constants.emptyGuid,
            DoctorId: this.currentProvider.providerID,
            ItemName: '',
            ItemDescription: '',
            ItemParameter: '',
            iOrder: highest + 1,
            xauditCreatedBy: this.authenticationService.currentUserValue.authdata.userid,
            xauditCreatedOn: undefined,
            xauditDeleted: false,
            xauditModifiedBy: this.authenticationService.currentUserValue.authdata.userid,
            xauditModifiedOn: undefined,
            xauditTableRowID: ''
        };
        // this.selectedReferralTreatment = this.newTreatment;
        this.procedures.unshift(this.selectedReferralTreatment);
        this.referralTreatmentTable.updateData(this.procedures.sort((a, b) => b.iOrder - a.iOrder));

        setTimeout(() => { // this will make the execution after update table has changed
            this.referralTreatmentTable.setSelectedModel(this.selectedReferralTreatment);
            this.inputTreatment.nativeElement.focus();
        }, 10);
    }


    createNewService() {
        const highest = Number(this.otherServices.sort((a, b) => b.iOrder - a.iOrder)[0].iOrder);
        this.selectedReferralOtherService = {
            ReferralOtherID: Constants.emptyGuid,
            DoctorId: this.currentProvider.providerID,
            ItemName: '',
            ItemDescription: '',
            ItemParameter: '',
            iOrder: highest + 1,
            xauditCreatedBy: this.authenticationService.currentUserValue.authdata.userid,
            xauditCreatedOn: undefined,
            xauditDeleted: false,
            xauditModifiedBy: this.authenticationService.currentUserValue.authdata.userid,
            xauditModifiedOn: undefined,
            xauditTableRowID: ''
        };
        this.otherServices.unshift(this.selectedReferralOtherService);
        this.referralOtherServiceTable.updateData(this.otherServices.sort((a, b) => b.iOrder - a.iOrder));

        setTimeout(() => {
            this.referralOtherServiceTable.setSelectedModel(this.selectedReferralOtherService);
            this.inputOtherService.nativeElement.focus();
        }, 10);
    }

    createReferralFromSelected() {
        this.showSameAs = true;
    }

    onChangeDateRanges(event) {
        this.selectedEnumReferralScheduleType = event.value;
    }


}
